module.exports = __webpack_public_path__ + "assets/img/download-note-text-0c38bb92.png";